/** Creates a type-safe field requirement checker from a list of required field names. */
export function createIsFieldRequired<T extends string>(requiredFields: T[]) {
  return (fieldName: T): boolean => requiredFields.includes(fieldName);
}
